module.exports = __webpack_public_path__ + "static/media/Swatantra_logo.508b1ad5.svg";